import { InfoOutlined } from "@mui/icons-material";
import SharedTranslations, {
  TranslationField,
} from "shared/components/Translations";
import TranslationInput from "shared/components/Translations/TranslationInput";
import { COLOR_LIGHT_BLUE } from "shared/theme/colors";
import { LocaleCode } from "shared/types/languages";
import { useMetadataTagDetails } from "../../../../context";
import { ManagedTranslations } from "../../../../context/types";
import { StyledInfoContainer, StyledInfoIconContainer } from "./styled";

const Translations = () => {
  const {
    metadataTagName,
    metadataSecondaryTags,
    translations,
    setTranslations,
    allowTranslationSecondaryTags,
  } = useMetadataTagDetails();
  const createFields = (): TranslationField[] => {
    const fields: TranslationField[] = [];
    fields.push({
      key: ManagedTranslations.PrimaryTagName,
      label: ManagedTranslations.PrimaryTagName,
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={
            language === LocaleCode.en ? metadataTagName?.input.value : value
          }
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              metadataTagName?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    });
    allowTranslationSecondaryTags &&
      metadataSecondaryTags.forEach((tag, idx) => {
        fields.push({
          key: `${ManagedTranslations.SecondaryTagName} ${idx}`,
          label: `${ManagedTranslations.SecondaryTagName} ${idx + 1}`,
          render: ({ language, value, onChange }) => (
            <TranslationInput
              defaultValue={language === LocaleCode.en ? tag : value}
              variant="filled"
              onChange={({ target: { value } }) => {
                  onChange(value);
              }}
            />
          ),
        });
      });
    return fields;
  };
  const createdFields = createFields();
  return (
    <>
      {!allowTranslationSecondaryTags && (
        <StyledInfoContainer>
          <StyledInfoIconContainer>
            <InfoOutlined fill={COLOR_LIGHT_BLUE} />
          </StyledInfoIconContainer>
          For this primary tag, secondary tag translations are accessible in
          game details
        </StyledInfoContainer>
      )}
      <SharedTranslations
        fields={createdFields}
        translations={translations}
        setTranslations={setTranslations}
      />
    </>
  );
};

export default Translations;
